module.exports = __webpack_public_path__ + "media/images/close-0908b4e8.png";